import React from "react";
import "./VerticalModeTest.scss";

const VerticalModeTest = () => {
    const [pageWidth, setPageWidth] = React.useState(window.innerWidth);
    const [pageHeight, setPageHeight] = React.useState(window.innerHeight);
    const [isVerticalMode, setIsVerticalMode] = React.useState(false);

    React.useEffect(() => {
        const handleResize = () => {
            setPageWidth(window.innerWidth);
            setPageHeight(window.innerHeight);
            setIsVerticalMode(window.innerWidth < window.innerHeight);
        };

        window.addEventListener("resize", handleResize);

        // Initial check
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    return (
        <div className={`content-page-container ${isVerticalMode ? "vertical-mode" : "horizontal-mode"}`}>
            <div className="content-page-top">
                <div className="fl-column grow">
                    <div className="fl-row grow">
                        <div>
                            <h1>Vertical Mode Test</h1>
                        </div>
                    </div>
                </div>
            </div>


            <div className="content-page-content-container">
                <div className="content-page-main-content">

                    <div className="vertical-mode-test-page-panel">

                        <div className="vertical-mode-test-info">
                            <p>Page Width: {pageWidth}px</p>
                            <p>Page Height: {pageHeight}px</p>
                            <p>Vertical Mode: {isVerticalMode ? "Yes" : "No"}</p>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default VerticalModeTest;

